<template>
  <div class="container">
    <h1>各システムへのリンク</h1>
    <p>
      各システムへのリンクを以下に記載いたします。
    </p>
    <div class="linkCollection">
      <ul>
        <li>
          <a href="https://dataplatform-yamanashi.jp/" target="_blank" rel="noopener noreferrer">ポータルサイト（やまなしデータプラットフォーム）</a>
        </li>
        <li>
          <a href="https://catalog.dataplatform-yamanashi.jp/" target="_blank" rel="noopener noreferrer">データカタログサイト（CKAN）</a>
        </li>
        <li>
          <a href="https://dashboard.dataplatform-yamanashi.jp/" target="_blank" rel="noopener noreferrer">簡易可視化ツール（WireCloud）</a>
        </li>
        <li>
          <a href="https://idm.dataplatform-yamanashi.jp/auth/realms/Smartcity/account/#/" target="_blank" rel="noopener noreferrer">認証システム（Keycloak）</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.container {
  width: 100%;
  margin: 36px 5%;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.linkCollection {
  padding: 12px 0 0 24px;
}

.linkCollection li {
  margin-bottom: 10px;
}
</style>
